import { PlatformLinkingConnectionStatus } from '@okletsplay/core';
import { Route } from 'app/enums';
import { PlatformLinkingState } from 'modules/platform-linking/store/interfaces';

export const setInternalRedirectReducer = (
  state: PlatformLinkingState,
  action: { payload: { pathname: string | Route } }
): void => {
  if (action.payload) {
    state.internalRedirectRoute = action.payload?.pathname;
  }
};

export const setLinkingConnectionStatusReducer = (
  state: PlatformLinkingState,
  {
    payload: { platformId, connectionStatus },
  }: { payload: { platformId: string; connectionStatus: PlatformLinkingConnectionStatus } }
): void => {
  const entity = state.entities[platformId];
  if (entity) {
    entity.connectionStatus = connectionStatus;
  }
};
